(function() {
    'use strict';

    var GestioneUtenteCtrl = function(
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        gestioneUtenteService,
        $uibModal,
        userSrvc
    ) {
        this.loading = 0;
        this.praticaVisibile = true;
        this.praticaPending = false;
        this.praticaTerminata = false;
        this.datiCliente = {};
        this.datiMito = null;
        this.praticaPic = null;
        this.TAB_LIST_MACRO = [];
        this.currentTabMacro = {};
        this.gestioneUtenteService = gestioneUtenteService;
        CblBrioLoader.hideLoader();

        const abilitazioniMock = false;
        this.gestioneUtenteService.reset();

        var self = this;
        this.init = () => {
            this.impostaTabs();
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            if (!!$stateParams.idPratica) {
                this.getPraticaByIdDaPic($stateParams.idPratica);                
                return;
            }
            if (!!$stateParams.ndg && !$stateParams.codiceUtente && !!$stateParams.codiceProdotto) {
                this.inizializzaDto($stateParams.ndg, $stateParams.codiceProdotto);
                return;
            }
            this.getDatiCliente($stateParams.codiceUtente);
        };

        let makeid = (length) => {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
              counter += 1;
            }
            return result;
        };
        this.gestioneUtenteService.cache = $cacheFactory(makeid(8));

        $scope.$watch('mitoForm', function (n, o, s) {
            if (n) {
                self.gestioneUtenteService.mitoForm = s.mitoForm;
            }
        }, true);

        this.initForm = () => {
            this.gestioneUtenteService.mitoForm = $scope.mitoForm;
        };

        this.setStatoRecuperoRapporti = function (value) { 
            gestioneUtenteService.rapportiCaricati = value; 
        };

        this.recuperaConfigurazioni = (defaultValue) => {
            gestioneUtenteService
                .recuperaConfigurazioni(this.praticaPic.tipo || defaultValue)
                .then(
                    (resp) => {
                        this.gestioneUtenteService.configurazioniBanca = {};
                        resp.data.result.forEach((item) => {
                            this.gestioneUtenteService.configurazioniBanca[item.codice] = {
                                "disabilitato": item.disabilitato,
                                "obbligatorio": item.obbligatorio,
                                "valoreDefault": item.valoreDefault,
                                "visibile": item.visibile
                            }
                        });
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
        };

        this.aggiornaStateParams = (flagIngressoDaSceltaUtenza) => {
            $stateParams.codiceUtente = this.datiMito.codiceUtente;
            $stateParams.idPratica = this.praticaPic.idPratica;
            $stateParams.step = this.praticaPic.step;
            $stateParams.ndg = this.praticaPic.intestatario.ndg;
            $stateParams.codiceProdotto = this.datiMito.datiAddebito.codiceListinoMito;

            if ((flagIngressoDaSceltaUtenza != null) && (flagIngressoDaSceltaUtenza != undefined)) {
                $stateParams.flagIngressoDaSceltaUtenza = flagIngressoDaSceltaUtenza;
            }
        };

        this.aggiornaServicePrincipale = (data) => {
            this.praticaPic = gestioneUtenteService.praticaPic = data;
            this.datiMito = gestioneUtenteService.datiMito = data.utenzaMito;
            gestioneUtenteService.rapportiCaricati = 0;

            this.datiCliente = data.intestatario;

            $stateParams.step = this.praticaPic.step;
        };

        this.ricaricaPagina = () => {
            let state = (this.verificaTipoPratica() == 'I') ? 'collocamentoUtenteMito' : 'gestioneUtenteMito';
            $state.transitionTo(state, $stateParams, {
                location: 'replace',
                inherit: true,
                reload: false,
                notify: false
            });
        };

        this.getDatiCliente = (codiceUtente) => {
            gestioneUtenteService
                .getDatiMito(codiceUtente)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        }
                        let dtoOutput = resp.data.result;
                        if (!dtoOutput) return;
                        if (!dtoOutput.stato ||
                            dtoOutput.stato.trim() == ''
                        ) {
                            dtoOutput.stato = 'INCORSO';
                        }
                        if (!dtoOutput.step || dtoOutput.step == 0) {
                            dtoOutput.step = 1;
                        }
                        this.datiMito = gestioneUtenteService.datiMito =
                        dtoOutput.utenzaMito;
                        gestioneUtenteService.rapportiCaricati = 0;
                        this.praticaPic = gestioneUtenteService.praticaPic =
                        dtoOutput;
                        if (!!this.praticaPic.idPratica && this.praticaPic.hidden) {
                            this.setPraticaNonVisibile(this.praticaPic.idPratica);
                        };
                        
                        if(!!this.praticaPic && !!this.praticaPic.idPratica){
                        	this.caricaCreatorePraticaPic(this.praticaPic.idPratica);
                        }
                        
                        this.recuperaConfigurazioni('VARIAZIONE');
                        
                        if (!!$stateParams.flagIngressoDaSceltaUtenza && !$stateParams.idPratica) {
                            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
                            if (!!this.praticaPic.stato && !!this.praticaPic.idPratica && 
                                (this.praticaPic.stato == 'INCORSO' ||
                                this.praticaPic.stato == 'CONSOLIDATA' ||
                                this.praticaPic.stato == 'PRESENTATA' ||
                                this.praticaPic.stato == 'DAREVISIONARE')) {
                                    this.praticaPending = true;
                            }                            
                            gestioneUtenteService.getDatiBusiness(codiceUtente)
                                .then(
                                    (res) => {
                                        if (messaggiFctr.processaResponse(res)) {
                                            return;
                                        }
                                        // Non sovrascrivo i dati addebito
                                        if (!!gestioneUtenteService.datiMito && !!gestioneUtenteService.datiMito.datiAddebito && !!gestioneUtenteService.datiMito.datiAddebito.contoAddebito)
                                            res.data.result.datiAddebito = gestioneUtenteService.datiMito.datiAddebito;
                                        this.datiMito = gestioneUtenteService.datiMito = res.data.result;

                                        // Recupero dei rapporti visibili
                                        this.setStatoRecuperoRapporti('LOADING');
                                        gestioneUtenteService.getRapportiVisibili(codiceUtente).then(
                                            (res) => {
                                                this.setStatoRecuperoRapporti('OK');
                                                if (messaggiFctr.processaResponse(res)) {
                                                    return;
                                                }
                                                // Aggiungo i rapporti
                                                this.datiMito.rapporti = gestioneUtenteService.datiMito.rapporti = res.data.result;
                                            },
                                            (error) => {
                                                messaggiFctr.processaResponse(error);
                                                this.setStatoRecuperoRapporti(error.status);
                                            }
                                        )
                                    },
                                    (error) => {
                                        messaggiFctr.processaResponse(error);
                                    }
                                )
                                .finally(
                                    () => {
                                        this.loading--;
                                    }
                                );
                                                         
                            gestioneUtenteService.getWizard(codiceUtente)
                            .then(
                                (res) => {
                                    if (messaggiFctr.processaResponse(res)) {
                                        return;
                                    }
                                    this.praticaPending = !res.data.result.variazioneAbilitata;
                                },
                                (error) => {
                                    messaggiFctr.processaResponse(error);
                                }
                            )
                            .finally(
                                () => {
                                    this.loading--;
                                }
                            );
                        } else if (!!$stateParams.idPratica) {
                            // Recupero dei rapporti visibili
                            this.setStatoRecuperoRapporti('LOADING');
                            gestioneUtenteService.getRapportiPraticaMito(codiceUtente).then(
                                (res) => {
                                    if (messaggiFctr.processaResponse(res)) {
                                        return;
                                    }
                                    // Aggiungo i rapporti
                                    this.datiMito.rapporti = gestioneUtenteService.datiMito.rapporti = res.data.result;
                                    this.setStatoRecuperoRapporti('OK');
                                },
                                (error) => {
                                    messaggiFctr.processaResponse(error);
                                    this.setStatoRecuperoRapporti(error.status);
                                }
                            )
                        }

                        $stateParams.flagIngressoDaSceltaUtenza = null;
                        this.setReadOnly();
                        this.caricaDatiCliente(this.datiMito.ndg || this.praticaPic.intestatario.ndg);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(
                    () => {
                        this.loading--;
                        this.gestioneUtenteService.configurazioniBanca = {
                            "NODATA": true
                        };
                    }
                );
        };

        this.caricaDatiCliente = (ndg) => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .getDatiCliente(ndg)
                .then(
                    (response) => {
                        if (messaggiFctr.processaResponse(response)) {
                            return;
                        }
                        this.datiCliente = response.data.result;
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => this.loading--);
        };

        this.getPraticaByIdDaPic = (idPratica) => {
            gestioneUtenteService
                .getPraticaByIdDaPic(idPratica)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        };

                        // Lo stato de revisionare è solo "di passaggio"
                        if (resp.data.result.stato == 'DAREVISIONARE') {
                            resp.data.result.step = 1;
                        }
                        
                        this.aggiornaServicePrincipale(resp.data.result);
                        this.aggiornaStateParams(null);
                        this.recuperaConfigurazioni();

                        if (['ACCETTATA', 'ANNULLATA', 'RIFIUTATA', 'PRESENTATA'].includes(this.praticaPic.stato)) {
                            $stateParams.flagIngressoDaSceltaUtenza = null;
                            gestioneUtenteService.readonly = true;
                            this.praticaTerminata = (this.praticaPic.stato != 'PRESENTATA');
                            this.caricaDatiCliente(!!this.datiMito.ndg ? this.datiMito.ndg : this.datiMito.idUtente);
                            this.caricaCreatorePraticaPic(this.praticaPic.idPratica);

                            if ((this.praticaPic.stato == 'PRESENTATA') && (this.praticaPic.tipo == "INSERIMENTO")) {
                                gestioneUtenteService.getDatiBusiness(this.datiMito.codiceUtente)
                                .then(
                                    (res) => {
                                        if (messaggiFctr.processaResponse(res)) {
                                            return;
                                        }
                                        
                                        let statoAttuale = res.data.result.stato;
                                        if (statoAttuale != "R") {
                                            let template =
                                                '<div class="ng-modal-overlay"></div>' +
                                                '<div class="row ng-modal-dialog">' +
                                                    '<div class="col-md-12 ng-modal-dialog-content" style="margin-bottom:10px; margin-top:10px;">' +
                                                        '<p style="font-weight: bold; color: red;">Attenzione: lo stato dell\'utenza Mito non &egrave; coerente con lo stato della pratica!</p>' +
                                                        '<p>Stato atteso: <strong>"R"</strong>, stato riscontrato: <strong>"' + statoAttuale +'"</strong></p>' +
                                                        '<p>Revisiona i dati della pratica.</p>' +
                                                    '</div>' +
                                                    '<div class="modal-footer">' +
                                                        '<button type="button" class="btn btn-default bfd-cancel" ng-click="cancel()">Chiudi</button>' +
                                                    '</div>' +
                                                '</div>';

                                            $uibModal.open({
                                                animation: true,
                                                template: template,
                                                backdrop: 'static',
                                                controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                                                    // Richiamato quando si chiude il popup
                                                    $scope.cancel = function () {
                                                        $uibModalInstance.dismiss('cancel');
                                                    };
                                                }]
                                            });

                                            // Inibire accettazione
                                        }
                                    },
                                    (error) => {
                                        messaggiFctr.processaResponse(error);
                                    }
                                )
                                .finally(() => this.loading--);
                            }

                        } else if (this.praticaPic.tipo == 'VARIAZIONE') {
                            gestioneUtenteService.readonly = (this.praticaPic.stato != 'CONSOLIDATA');
                            this.setStatoRecuperoRapporti('LOADING');

                            gestioneUtenteService.getRapportiPraticaByIdDaPic($stateParams.idPratica).then(
                                (resp) => {
                                    if (messaggiFctr.processaResponse(resp)) {
                                        return;
                                    };
                                    
                                    this.praticaPic.utenzaMito.rapporti = resp.data.result;
                                    this.setStatoRecuperoRapporti('OK');
                                },
                                (error) => {
                                    messaggiFctr.processaResponse(error);
                                    this.setStatoRecuperoRapporti(error.status);
                                }
                            );
                        }
                        
                        this.impostaTabs();
                        this.ricaricaPagina();
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => this.loading--);
        };

        this.inizializzaDto = (ndg, codiceProdotto) => {
            gestioneUtenteService
                .getDefaultDto(ndg, codiceProdotto)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        };
                        if (!resp.data.result.utenzaMito.codiceUtente) {
                            resp.data.result.utenzaMito.codiceUtente = '-';
                        }
                        
                        this.praticaPic = gestioneUtenteService.praticaPic = resp.data.result;
                        this.datiCliente = gestioneUtenteService.praticaPic.intestatario;

                        // https://youtrack.cabel.network/issue/CBC-8867
                        if (!gestioneUtenteService.praticaPic.utenzaMito.tol) gestioneUtenteService.praticaPic.utenzaMito.tol = ' ';
                        if (!gestioneUtenteService.praticaPic.utenzaMito.hb) gestioneUtenteService.praticaPic.utenzaMito.hb = ' ';

                        this.datiMito = gestioneUtenteService.datiMito = gestioneUtenteService.praticaPic.utenzaMito;
                        gestioneUtenteService.rapportiCaricati = 0;

                        this.impostaCurrentTabEsterno();
                        this.setReadOnly();
                        this.recuperaConfigurazioni();
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => this.loading--);
        };

        this.caricaCreatorePraticaPic = (idPratica) => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .getCreatorePraticaPic(idPratica)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        };
                        this.gestioneUtenteService.creatorePratica = resp.data.result;
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => this.loading--);
        };

        this.verificaTipoPratica = () => {
            if (!!this.praticaPic && (this.praticaPic.tipo == 'INSERIMENTO')) {
                return 'I';
            }
            if (!!this.praticaPic && (this.praticaPic.tipo == 'VARIAZIONE')) {
                return 'V';
            }
            return '';
        };
        
        this.setReadOnly = () => {
            if (this.verificaTipoPratica() == 'V') {
                let idPraticaEsistente = ($stateParams.idPratica != null) && 
                    (($stateParams.idPratica > 0) || (this.praticaPic.idPratica > 0));
                
                gestioneUtenteService.readonly = idPraticaEsistente && (this.praticaPic.stato != 'CONSOLIDATA');
            } else if (this.verificaTipoPratica() == 'I') {
                let idPraticaEsistente = ($stateParams.idPratica != null) && (this.praticaPic != null) &&
                    (($stateParams.idPratica > 0) || (this.praticaPic.idPratica > 0));

                gestioneUtenteService.readonly = idPraticaEsistente && (this.praticaPic.canale != userSrvc.cabelUser.canale);
            } else {
                gestioneUtenteService.readonly = true;
            }
            this.impostaTabs();
            this.impostaCurrentTab();
            this.impostaCurrentTabEsterno();
        };

        this.getStyleTabMacroReadOnly = function(currentTabIndex) {
            if (gestioneUtenteService.readonly) {
                if (currentTabIndex < this.currentTabMacro.index) {
                    return 'progress-next-read';
                }

                if (currentTabIndex == this.currentTabMacro.index) {
                    return 'progress-current-read';
                }

                return 'progress-next-read';
            }
            if (currentTabIndex < self.currentTabMacro.index) {
                return 'progress-pass';
            }
            if (currentTabIndex == self.currentTabMacro.index) {
                return 'progress-current';
            }
            return 'progress-next';
        };

        this.getStyleStepMicro = function(currentTabIndex) {
            if (gestioneUtenteService.readonly) {
                return 'step read';
            }

            if ((currentTabIndex !== this.currentTabMacro.index) && (this.verificaTipoPratica() == 'V')) {
                return 'step success';
            }

            if ((currentTabIndex < this.currentTabMacro.index) && (this.verificaTipoPratica() == 'I')) {
                return 'step success';
            }

            return 'step';
        };
        this.getStyleTabMicroReadOnly = function(currentTabIndex) {
            if (gestioneUtenteService.readonly) {
                if (currentTabIndex == this.currentTabMacro.index) {
                    return 'ab-step-tabs cliccabile active-read';
                }

                return 'ab-step-tabs cliccabile ab-last-read';
            }
            if (currentTabIndex < self.currentTabMacro.index) {
                return 'ab-step-tabs';
            }
            if (currentTabIndex == self.currentTabMacro.index) {
                return 'ab-step-tabs active';
            }
            return 'ab-step-tabs ab-last';
        };

        this.getStyleTabEsternoReadOnly = function(currentTabEsternoIndex) {
            if (gestioneUtenteService.readonly) {
                if (currentTabEsternoIndex < this.currentTabEsterno.index) {
                    return 'progress-next-read';
                }

                if (currentTabEsternoIndex == this.currentTabEsterno.index) {
                    return 'progress-current-read';
                }

                return 'progress-next-read';
            }
            if (currentTabEsternoIndex < self.currentTabEsterno.index) {
                return 'progress-pass';
            }
            if (currentTabEsternoIndex == self.currentTabEsterno.index) {
                return 'progress-current';
            }
            return 'progress-next';
        };

        this.macroTabClicked = function(tab) {
            if (!gestioneUtenteService.readonly) {
                return;
            }

            self.currentTabMacro = tab;
            self.praticaPic.step = tab.index + 1;
        };

        this.vaiAdInvioCredenziali = () => {
        	$stateParams.flagIngressoDaSceltaUtenza = true;
            $state.go('invioCredenzialiMito', $stateParams);
        };

        this.gotoAudit = () => {
        	$state.go('auditEventi', $stateParams);
        };

        this.gotoVipPage = () => {
        	$state.go('vipPage', $stateParams);
        };

        this.setPraticaNonVisibile = (idPratica) => {
            const message = {
                type: 'W',
                message: 'Pratica ' + idPratica + ' non visibile.'
            };
            messaggiFctr.addMessage(message);
            this.praticaVisibile = false;
        };

        this.contoAddebitoDefinito = () => {
            if (!this.datiMito.datiAddebito.contoAddebito) return false;
            if (this.datiMito.datiAddebito.contoAddebito == 0) return false;
            return true;
        };

        this.contattoPrincipalePresente = () => {
            let principalePresente = false;
            this.datiMito.elencoContatti.forEach((num) => {
                if (!!num.principale) principalePresente = true;
            });
            return principalePresente;
        };

        this.annullaPratica = () => {
            if (!this.praticaPic.idPratica) {
                $stateParams.idPratica = null;
                $stateParams.step = null;

                let stateName = this.praticaPic.tipo == 'INSERIMENTO' ? 'schedaCliente' : $state.current;
                let stateParams = this.praticaPic.tipo == 'INSERIMENTO' ? { 'ndg': $stateParams.ndg } : $stateParams;
                $state.go(stateName, stateParams);
                return;
            }
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            let stateRedirect = (this.praticaPic.tipo == 'INSERIMENTO') ? ['schedaCliente', { 'ndg': $stateParams.ndg }, { reload: true }] : [$state.current, $stateParams, { reload: true }];
            // aggiorna i dati della pratica
            gestioneUtenteService
                .annullaPraticaPic({ "idPratica": this.praticaPic.idPratica, "nota": '' })
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        $stateParams.idPratica = null;
                        $state.go.apply(null, stateRedirect);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        this.abilitaModifica = () => {
            gestioneUtenteService.readonly = false;
            this.avviaPraticaDiModifica();
        };

        this.proseguiPratica = () => {
            messaggiFctr.resetMessages();
            if (!$scope.mitoForm.$valid) {
                this.gestioneUtenteService.cache.put('action', true);
                this.gestioneUtenteService.sottomesso = true;
                
                let campiMancanti = '';
                if ($scope.mitoForm.$error && $scope.mitoForm.$error.required) {
                    let listaCampi = [];
                    $scope.mitoForm.$error.required.forEach((field) => { listaCampi.push(field.$name); });
                    campiMancanti = ': [' + listaCampi.join(', ') + ']';
                }
                messaggiFctr.addMessage({
                    type: 'W',
                    message: 'Sono presenti campi non correttamente compilati' + campiMancanti
                });
                return;
            };

            let avanzaStep = () => {
                this.loading = (this.loading > 0) ? this.loading + 1 : 1;
                // aggiorna i dati della pratica
                this.praticaPic.utenzaMito = gestioneUtenteService.datiMito;
                gestioneUtenteService
                    .avanzaPraticaPic(this.praticaPic)
                    .then(
                        (res) => {
                            if (messaggiFctr.processaResponse(res)) {
                                return;
                            }
                            this.aggiornaServicePrincipale(res.data.result);
                            this.impostaCurrentTab();
                            this.impostaCurrentTabEsterno();
                            this.aggiornaStateParams(null);
                            this.ricaricaPagina();
                        },
                        (error) => {
                            messaggiFctr.processaResponse(error);

                            if (!$stateParams.idPratica && error.data.result) {
                                this.aggiornaServicePrincipale(error.data.result);
                                this.impostaCurrentTab();
                                this.impostaCurrentTabEsterno();
                                this.aggiornaStateParams(null);
                                this.ricaricaPagina();
                            }
                        }
                    )
                    .finally(() => {
                        this.gestioneUtenteService.sottomesso = false;
                        this.loading--;
                    });
            };

            if (!this.datiMito.datiAddebito || !this.datiMito.datiAddebito.contoAddebito || (this.datiMito.datiAddebito.contoAddebito == 0)) {
                $uibModal.open({
                    templateUrl: CONSTANTS.BASE_ROOT + 'modals/contoMancante/contoMancante.modal.html',
                    controller: 'MitomContoMancanteController',
                    controllerAs: 'contoMancanteCtrl'
                }).result.then(
                    (res) => {
                        avanzaStep();
                    }
                );
                return;
            }
            avanzaStep();
        };

        this.consolidaPratica = () => {
            messaggiFctr.resetMessages();
            if (!$scope.mitoForm.$valid) {
                this.gestioneUtenteService.cache.put('action', true);
                this.gestioneUtenteService.sottomesso = true;
                
                let campiMancanti = '';
                if ($scope.mitoForm.$error && $scope.mitoForm.$error.required) {
                    let listaCampi = [];
                    $scope.mitoForm.$error.required.forEach((field) => { listaCampi.push(field.$name); });
                    campiMancanti = ': [' + listaCampi.join(', ') + ']';
                }
                messaggiFctr.addMessage({
                    type: 'W',
                    message: 'Sono presenti campi non correttamente compilati' + campiMancanti
                });
                return;
            };

            if ((this.praticaPic.step == 2) && (this.verificaTipoPratica() == 'I')) {
                let canaleInvioUtenza = this.gestioneUtenteService.datiMito.canaleInvioUtenza;
                let canaleInvioPassword = this.gestioneUtenteService.datiMito.canaleInvioPassword;
                if (canaleInvioUtenza == canaleInvioPassword) {
                    messaggiFctr.addMessage({
                        type: 'E',
                        message: 'Non è possibile procedere con il collocamento, si prega di selezionare due canali di invio diversi per il codice utente e la password'
                    });
                    return;
                } 
            }

            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            this.praticaPic.utenzaMito = gestioneUtenteService.datiMito;
            gestioneUtenteService.getProdottoDisponibile(gestioneUtenteService.datiMito.datiAddebito.codiceListinoMito)
                .then(
                    (result) => {
                        this.loading = (this.loading > 0) ? this.loading + 1 : 1;
                        gestioneUtenteService.consolidaPraticaPic(this.praticaPic)
                            .then(
                                (res) => {
                                    if (messaggiFctr.processaResponse(res)) {
                                        return;
                                    }
                                    this.aggiornaServicePrincipale(res.data.result);
                                    this.impostaCurrentTab();
                                    this.impostaCurrentTabEsterno();
                                    this.aggiornaStateParams(null);
                                    this.setReadOnly();
                                },
                                (error) => {
                                    messaggiFctr.processaResponse(error);
                                }
                            )
                            .finally(() => this.loading--);
                    },
                    (error) => {
                        // L'errore non va segnalato: vuol dire che non esiste il prodotto
                        messaggiFctr.addMessage({
                            type: 'E',
                            message: 'Il listino MITO selezionato non è più disponibile: si prega di cambiare valore'
                        });
                    }
                )
                .finally(() => this.loading--);
        };

        this.actionWithNote = (idPratica, message, nextCallback) => {
            messaggiFctr.resetMessages();
            let noteBackofficeModal = '';
            let idPraticaModal = this.praticaPic.idPratica;
            let operationMessageModal = message;
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/gestioneNote/gestioneNote.modal.html',
                resolve: {
                    idPratica: function () {
                        return idPraticaModal;
                    },
                    message: function () {
                        return operationMessageModal;
                    },
                    noteBackoffice: function () {
                        return noteBackofficeModal;
                    }
                },
                controller: 'MitomGestioneNoteController',
                controllerAs: 'gestioneNoteCtrl'
            }).result.then(function (data) {
                let serviceParams = {
                    idPratica: idPratica,
                    nota: data
                };
                nextCallback(serviceParams);
            }, function (error) {
                if (error && error !== 'cancel') {
                    messaggiFctr.processaResponse(error);
                }
            });
        };

        this.presentaPraticaAction = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            let stateRedirect = ['schedaCliente', { 'ndg': $stateParams.ndg }, { reload: true }];
            // aggiorna i dati della pratica
            gestioneUtenteService
                .presentaPraticaPic({ "idPratica": this.praticaPic.idPratica, "nota": null })
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        $state.go.apply(null, stateRedirect);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);

                        if (error.data.result && ((error.data.result.stato != this.praticaPic.stato) || (error.data.result.step != this.praticaPic.step))) {
                            this.aggiornaServicePrincipale(error.data.result);
                            this.impostaCurrentTab();
                            this.impostaCurrentTabEsterno();
                            this.aggiornaStateParams(null);
                            this.ricaricaPagina();
                        }
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        this.presentaPratica = () => {
            this.actionWithNote(this.praticaPic.idPratica, 'Presenta pratica', this.presentaPraticaAction);
        };

        this.salvaModifiche = () => {
            messaggiFctr.resetMessages();
            if (!$scope.mitoForm.$valid) {
                this.gestioneUtenteService.cache.put('action', true);
                this.gestioneUtenteService.sottomesso = true;
                let campiMancanti = '';
                if ($scope.mitoForm.$error && $scope.mitoForm.$error.required) {
                    let listaCampi = [];
                    $scope.mitoForm.$error.required.forEach((field) => { listaCampi.push(field.$name); });
                    campiMancanti = ': [' + listaCampi.join(', ') + ']';
                }
                messaggiFctr.addMessage({
                    type: 'W',
                    message: 'Sono presenti campi non correttamente compilati' + campiMancanti
                });
                return;
            }

            if (!!this.praticaPic.idPratica && !this.contattoPrincipalePresente() && (this.verificaTipoPratica() == 'V')) {
                this.gestioneUtenteService.sottomesso = true;
                messaggiFctr.addMessage({
                    type: 'W',
                    message: 'Nessun contatto principale individuato.'
                });
                return;
            }

            if ((this.praticaPic.step == 2) && (this.verificaTipoPratica() == 'I')) {
                let canaleInvioUtenza = this.gestioneUtenteService.datiMito.canaleInvioUtenza;
                let canaleInvioPassword = this.gestioneUtenteService.datiMito.canaleInvioPassword;
                if (canaleInvioUtenza == canaleInvioPassword) {
                    messaggiFctr.addMessage({
                        type: 'E',
                        message: 'Non è possibile procedere con il collocamento, si prega di selezionare due canali di invio diversi per il codice utente e la password'
                    });
                    return;
                } 
            }

            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            // aggiorna i dati della pratica
            this.praticaPic.utenzaMito = gestioneUtenteService.datiMito;
            gestioneUtenteService.salvaPraticaPic(this.praticaPic)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        this.aggiornaServicePrincipale(res.data.result);
                        gestioneUtenteService.readonly = true;

                        this.aggiornaStateParams(null);
                        this.impostaCurrentTab();
                        this.impostaCurrentTabEsterno();
                        this.setReadOnly();
                        this.ricaricaPagina();
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);

                        if (!$stateParams.idPratica && error.data.result) {
                            this.aggiornaServicePrincipale(error.data.result);
                            this.impostaCurrentTab();
                            this.impostaCurrentTabEsterno();
                            this.aggiornaStateParams(null);
                            this.ricaricaPagina();
                        }
                    }
                )
                .finally(() => {
                    this.gestioneUtenteService.sottomesso = false;
                    this.loading--;
                });
        };

        this.accettaPratica = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .accettaPraticaPic({ "idPratica": this.praticaPic.idPratica, "nota": null })
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        messaggiFctr.addSuccessMessage({message: 'Accettazione completata con successo'});
                        this.praticaPic.stato = gestioneUtenteService.praticaPic.stato =
                            'ACCETTATA';
                        $stateParams.idPratica = null;
                        $state.go($state.current, $stateParams, { reload: true });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        this.revisionaPratica = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .revisionaPraticaPic({ "idPratica": this.praticaPic.idPratica, "nota": null })
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        $state.go.apply(null, ['schedaCliente', { 'ndg': $stateParams.ndg }, { reload: true }]);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };
        
        this.prendiInCaricoPratica = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .prendiInCaricoPratica({ "idPratica": this.praticaPic.idPratica, "nota": null })
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        this.praticaPic.incaricato = userSrvc.user.utente;
                        this.ricaricaPagina();
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };
        
        this.rilasciaPratica = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .rilasciaPratica({ "idPratica": this.praticaPic.idPratica, "nota": null })
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        this.praticaPic.incaricato = null;
                        this.ricaricaPagina();
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };
        
        this.rifiutaPratica = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .rifiutaPratica({ "idPratica": this.praticaPic.idPratica, "nota": null })
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        let stateRedirect = (this.praticaPic.tipo == 'INSERIMENTO') ? ['schedaCliente', { 'ndg': $stateParams.ndg }, { reload: true }] : [$state.current, $stateParams, { reload: true }];
                        $state.go.apply(null, stateRedirect);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        this.spostaInStatoInCorso = () => {
            if (!this.praticaPic.idPratica) {
                $stateParams.idPratica = null;
                $state.go($state.current, $stateParams);
                return;
            }
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService
                .spostaInStatoInCorso(this.praticaPic)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        this.praticaPic.stato = gestioneUtenteService.praticaPic.stato =
                            'INCORSO';
                        $stateParams.idPratica = this.praticaPic.idPratica;
                        this.setReadOnly();
                        $state.go($state.current, $stateParams);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        this.tornaIndietro = () => {
            this.praticaPic.step = this.praticaPic.step > 1 ? this.praticaPic.step - 1 : 1;
            gestioneUtenteService.praticaPic = this.praticaPic;
            this.impostaTabs();
        };

        this.avviaPraticaDiModifica = () => {
            if (!!this.praticaPic.stato &&
                this.praticaPic.stato == 'DAREVISIONARE'
            ) {
                this.spostaInStatoInCorso();
                return;
            }
            if (this.praticaPic.idPratica == null) {
                if (this.datiMito.email == null) {
                    this.datiMito.email = gestioneUtenteService.datiMito.email = "";
                }

                // https://youtrack.cabel.network/issue/CBC-8867
                if (!gestioneUtenteService.praticaPic.utenzaMito.tol) gestioneUtenteService.praticaPic.utenzaMito.tol = ' ';
                if (!gestioneUtenteService.praticaPic.utenzaMito.hb) gestioneUtenteService.praticaPic.utenzaMito.hb = ' ';
                
                this.loadingPraticaVariazione = true;
                gestioneUtenteService.creaPraticaVariazione(this.datiMito.codiceUtente)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        this.aggiornaServicePrincipale(res.data.result);
                        this.impostaCurrentTab();
                        this.impostaCurrentTabEsterno();
                        this.aggiornaStateParams(null);

                        if (!res.data.result.utenzaMito?.email || (res.data.result.utenzaMito.email.length == 0)) {
                            messaggiFctr.addMessage({
                               "type": "W",
                               "message": "Indirizzo e-mail mancante o errato" 
                            });
                        }
                        
                        $state.go($state.current, $stateParams);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loadingPraticaVariazione = false;
                });                
            } 
        };

        this.impostaTabs = () => {
            this.TAB_LIST_MACRO = [];
            // Step principali
            this.TAB_LIST_MACRO.push({
                index: 0,
                title: 'Dati utente mito'
            });

            if (this.verificaTipoPratica() != 'I') {
                this.TAB_LIST_MACRO.push({
                    index: 1,
                    title: 'Accesso e notifiche'
                });
                this.TAB_LIST_MACRO.push({
                    index: 2,
                    title: 'Visibilità Rapporti'
                });
            } else if (this.verificaTipoPratica() == 'I') {
                this.TAB_LIST_MACRO.push({
                    index: 1,
                    title: 'Comunicazione credenziali'
                });
            }
            
            this.TAB_ESTERNO_LIST = [];
            // Macro step
            this.TAB_ESTERNO_LIST.push({
                index: 0,
                title: '1 - GESTIONE UTENTE MITO'
            });
            if (!gestioneUtenteService.readonly || (gestioneUtenteService.readonly && !!$stateParams.idPratica)) {
                this.TAB_ESTERNO_LIST.push({
                    index: 1,
                    title: '2 - GESTIONE DOCUMENTI'
                });
            }

            if (!this.praticaPic) {
                this.currentTabEsterno = this.TAB_ESTERNO_LIST[0];
                this.currentTabMacro = this.TAB_LIST_MACRO[0];
            } else if ((this.verificaTipoPratica() == 'I') && (this.praticaPic.stato == 'INCORSO')) {
                this.currentTabEsterno = this.TAB_ESTERNO_LIST[0];
                this.currentTabMacro = this.TAB_LIST_MACRO[this.praticaPic.step - 1];
            } else if (this.praticaPic.stato == 'CONSOLIDATA') {
                this.currentTabEsterno = this.TAB_ESTERNO_LIST[1];
                this.currentTabMacro = this.TAB_LIST_MACRO[0];
            } else {
                this.currentTabEsterno = this.TAB_ESTERNO_LIST[0];
                this.currentTabMacro = this.TAB_LIST_MACRO[0];
            }
        };

        this.impostaCurrentTab = () => {
            this.currentTabMacro = this.TAB_LIST_MACRO[this.praticaPic.step - 1];
        };

        this.impostaCurrentTabEsterno = (indice) => {
            switch (indice) {
                case 0:
                case 1:
                    this.currentTabEsterno = this.TAB_ESTERNO_LIST[indice];
                    break;            
                default:
                    this.currentTabEsterno = !!this.praticaPic.stato && this.praticaPic.stato == 'CONSOLIDATA' ?
                        this.TAB_ESTERNO_LIST[1] :
                        this.TAB_ESTERNO_LIST[0];
                    break;
            }
        };

        this.isContenutoVisibile = (componente) => {
            let indice = this.currentTabMacro.index;
            let tipoInserimento = this.verificaTipoPratica() == 'I';

            switch (componente) {
                case 'DATI_UTENTE':
                    return (indice == 0);
                case 'NOTIFICHE':
                    return (indice == 1) && !tipoInserimento;
                case 'CREDENZIALI':
                    return (indice == 1) && tipoInserimento;
                case 'RAPPORTI':
                    return (indice == 2);
                default:
                    return false;
            }
        };

        this.pulsantieraVisibile = () => {
            return !(this.loading > 0) && !this.praticaPending && !this.praticaTerminata;
        };

        this.buttonVisible = (tipo) => { 
            let particaEsistente = !!this.praticaPic.idPratica && (this.praticaPic.idPratica > 0);
            let solaLettura = this.gestioneUtenteService.readonly;
            let statoIncorso = ['INCORSO', 'DAREVISIONARE'].includes(this.praticaPic.stato);
            let statoConsolidata = this.praticaPic.stato == 'CONSOLIDATA';
            let statoPresentata = this.praticaPic.stato == 'PRESENTATA';
            let tipoInserimento = this.verificaTipoPratica() == 'I';
            let tipoVariazione = this.verificaTipoPratica() == 'V';

            switch (tipo) {
                case 'INVIO_CREDENZIALI':
                    return !particaEsistente && solaLettura && this.invioCredenzialiAbilitato();   
                case 'SWITCH_MITO':
                    return !particaEsistente && solaLettura && this.switchUtenzeMitoAbilitato(); 
                case 'ESTINGUI_MITO':
                    return !particaEsistente && solaLettura && this.estinguiUtenzaMitoAbilitato();
                case 'RIBALTA_CONTI':
                    return !particaEsistente && solaLettura && this.ribaltamentoContiAbilitato();
                case 'AUDIT':
                    return solaLettura && this.auditAbilitato();  
                case 'VIP':
                    return solaLettura && this.vipAbilitato();            
                case 'ANNULLA_PRATICA':
                    return (!solaLettura || (particaEsistente && solaLettura)) && !statoPresentata;
                case 'MODIFICA':
                    return !particaEsistente && solaLettura && this.modificaAbilitato();
                case 'MODIFICA_DATI':
                    return solaLettura && particaEsistente && this.modificaAbilitato();
                case 'PRENDI_IN_CARICO':
                    return solaLettura && particaEsistente && this.prendiIncaricoAbilitato();
                case 'RILASCIA':
                    return solaLettura && particaEsistente && this.rilasciaAbilitato();
                case 'RIFIUTA':
                    return solaLettura && particaEsistente && this.rilasciaAbilitato();
                case 'REVISIONA':
                    return solaLettura && particaEsistente && this.accettaAbilitato();
                case 'ACCETTA':
                    return solaLettura && particaEsistente && this.accettaAbilitato();
                case 'SALVA':
                    return ((tipoInserimento && [1, 2].includes(this.praticaPic.step)) || (tipoVariazione && !solaLettura && particaEsistente)) && statoIncorso;
                case 'CONSOLIDA':
                    return particaEsistente && statoIncorso && ((tipoVariazione && solaLettura) || (tipoInserimento && !solaLettura && (this.praticaPic.step == 2)));
                case 'PROSEGUI':
                    return statoIncorso && tipoInserimento && (this.praticaPic.step == 1);
                case 'INDIETRO':
                    return statoIncorso && tipoInserimento && (this.praticaPic.step == 2);
                case 'PRESENTA':
                    return !solaLettura && statoConsolidata && [3, 6].includes(this.praticaPic.step);
                default:
                    return false;
            }
        };

        this.isGoupButtonVisible = (tipo) => {
            switch (tipo) {
                case 'POSIZIONE':
                    return this.buttonVisible('INVIO_CREDENZIALI') || this.buttonVisible('AUDIT') || this.buttonVisible('VIP');
                case 'SERVIZI':
                    return this.buttonVisible('SWITCH_MITO') || this.buttonVisible('ESTINGUI_MITO');
                default:
                    return false;
            }
        };

        this.getMenu = (root, child) => {
            if (!child) {
                return this.gestioneUtenteService.getMenu()[root].TITLE;
            }
            return this.gestioneUtenteService.getMenu()[root][child];
        };

        this.consolidaAbilitato = () => {
            return (
                abilitazioniMock ||
                (userSrvc.consolidaAbilitata() && this.praticaPic.stato == 'INCORSO')
            );
        };

        this.modificaAbilitato = () => {
            return (
                abilitazioniMock ||
                (
                    userSrvc.modificaAbilitata() && 
                    this.datiMito.stato !== 'N' && 
                    ['INCORSO', 'CONSOLIDATA'].includes(this.praticaPic.stato)
                ) || this.praticaPic.stato == 'DAREVISIONARE'
            );
        };

        this.prendiIncaricoAbilitato = () => {
            return (
                (this.praticaPic.stato == 'PRESENTATA' &&
                    userSrvc.user.utente !== this.praticaPic.incaricato && 
                    userSrvc.incaricatoAbilitata() && 
                    !userSrvc.controlloAccettazioneAbilitata()) || 
                (this.praticaPic.stato == 'PRESENTATA' &&
                    userSrvc.user.utente !== this.praticaPic.incaricato && 
                    userSrvc.incaricatoAbilitata() && 
                    userSrvc.controlloAccettazioneAbilitata() && userSrvc.user.utente !== this.gestioneUtenteService.creatorePratica)
            );
        };
        
        this.rilasciaAbilitato = () => {
            return (            		
                (this.praticaPic.stato == 'PRESENTATA' &&
                    userSrvc.user.utente == this.praticaPic.incaricato && 
                    userSrvc.incaricatoAbilitata() && 
                    !userSrvc.controlloAccettazioneAbilitata()) || 
                (this.praticaPic.stato == 'PRESENTATA' &&
                    userSrvc.user.utente == this.praticaPic.incaricato && 
                    userSrvc.incaricatoAbilitata() && 
                    userSrvc.controlloAccettazioneAbilitata() && userSrvc.user.utente !== this.gestioneUtenteService.creatorePratica)
            );
        };

        this.accettaAbilitato = () => {
            return (
                abilitazioniMock ||
                (this.praticaPic.stato == 'PRESENTATA' &&
                    userSrvc.user.utente == this.praticaPic.incaricato && 
                    userSrvc.incaricatoAbilitata() && 
                    !userSrvc.controlloAccettazioneAbilitata()) || 
                (this.praticaPic.stato == 'PRESENTATA' &&
                    userSrvc.user.utente == this.praticaPic.incaricato && 
                    userSrvc.incaricatoAbilitata() && 
                    userSrvc.controlloAccettazioneAbilitata() && userSrvc.user.utente !== this.gestioneUtenteService.creatorePratica)
            );
        };

        this.invioCredenzialiAbilitato = () => {
            return (
                (abilitazioniMock || userSrvc.invioCredenzialiAbilitata()) &&
                !!this.praticaPic && this.datiMito.stato !== 'N' 
            );
        };

        this.switchUtenzeMitoAbilitato = () => {
            // Da verificare le reali condizioni di attivazione del pulsante
            return userSrvc.switchUtenzaAbilitata() && !!this.praticaPic && (this.datiMito.stato !== 'N');
        };

        this.estinguiUtenzaMitoAbilitato = () => {
            return userSrvc.estinguiUtenzaAbilitata() && !!this.praticaPic && (this.datiMito.stato !== 'N');
        };

        this.ribaltamentoContiAbilitato = () => {
            return userSrvc.ribaltamentoContiAbilitata() && !!this.praticaPic && (this.datiMito.stato !== 'N');
        };

        this.auditAbilitato = () => {
            return userSrvc.auditAbilitata();
        };

        this.vipAbilitato = () => {
            return userSrvc.vipAbilitato();
        };

        this.switchUtenza = () => {
            let idOrganizzazione = this.datiMito.idOrganizzazione;
            let codiceUtenteMito = this.datiMito.codiceUtente;
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;

            gestioneUtenteService
                .recuperaDnsMito(idOrganizzazione)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res)) {
                            return;
                        }
                        let dns = res.data.result;
                        if (dns.includes(';')) {
                            // In caso di più DNS prendo sempre il primo
                            dns = dns.split(';')[0];
                        }
                        let inputServizio = {
                            "codiceUtente": codiceUtenteMito
                        };

                        gestioneUtenteService
                            .creaAttivazione(inputServizio)
                            .then(
                                (res) => {
                                    if (messaggiFctr.processaResponse(res)) {
                                        return;
                                    }
                                    let data = res.data;
                                    if (data.eccezione || !data.codiceAttivazione) {
                                        messaggiFctr.addMessage({
                                            "type": 'E',
                                            "message": data.messaggio
                                        });
                                    } else {
                                        let url = window.location.protocol+"//" + dns + '/CBL-MITO-WA/?v=no&id=' + data.codiceAttivazione;
                                        window.open(url);
                                    }
                                },
                                (error) => {
                                    messaggiFctr.processaResponse(error);
                                }
                            )
                            .finally(() => {
                                this.loading--;
                            });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                        this.loading--;
                    }
                );
        };

        this.estinguiUtenza = () => {
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/estinzione/estinzione.modal.html',
                controller: 'MitomEstinzioneController',
                controllerAs: 'estinzioneCtrl'
            }).result.then(
                (res) => {
                    let codiceUtenteMito = this.datiMito.codiceUtente;
                    this.loading = (this.loading > 0) ? this.loading + 1 : 1;

                    gestioneUtenteService
                        .estinguiUtenzaMito(codiceUtenteMito)
                        .then(
                            (res) => {
                                if (!res || messaggiFctr.processaResponse(res)) {
                                    return;
                                }

                                messaggiFctr.addSuccessMessage({message: 'Estinzione completata con successo'});
                                $state.go.apply(null, ['schedaCliente', { 'ndg': $stateParams.ndg }, { reload: true }]);
                            },
                            (error) => {
                                messaggiFctr.processaResponse(error);
                            }
                        )
                        .finally(() => {
                            this.loading--;
                        });
                }
            );
        };

        this.ribaltaRapporti = () => {
            let codiceUtenteMito = this.datiMito.codiceUtente;
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;

            gestioneUtenteService
                .ribaltaRapporti(codiceUtenteMito)
                .then(
                    (res) => {
                        if (!res || messaggiFctr.processaResponse(res)) {
                            return;
                        }

                        messaggiFctr.addSuccessMessage({message: 'Ribaltamento completato con successo'});
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        this.init();
    };

    GestioneUtenteCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomGestioneUtenteService',
        '$uibModal',
        'MitomUserSrvc'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/gestioneUtente.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var GestioneUtenteComponent = {
        controller: GestioneUtenteCtrl,
        controllerAs: 'gestioneUtenteCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomgestioneUtente', GestioneUtenteComponent);
})();